// src/lib/hooks/admin/useUsageUsers.ts
import { useQuery } from '@tanstack/react-query';
import { fetchUsageUsers } from '@/lib/api/admin';
import type { UsersFilters, PaginatedResponse, UserUsageRow } from '@/types/admin';
import { usageKeys } from './useUsageOverview';

export const useUsageUsers = (filters: UsersFilters, enabled = true) => {
  return useQuery<PaginatedResponse<UserUsageRow>>({
    queryKey: usageKeys.users(filters),
    queryFn: () => fetchUsageUsers(filters),
    enabled,
    staleTime: 60 * 1000,
  });
};
